import React, {ComponentType, ExoticComponent, FC, Suspense} from "react";

const loading = () => <div className="d-flex justify-content-center align-items-center mt-3">
    <div className="spinner-border text-primary" role="status"/>
</div>;


type LoadComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element> | FC<object> | ExoticComponent<unknown>;
    fallback?: JSX.Element;
};

export const LoadComponent = ({component: Component, fallback}: LoadComponentProps) => (
    <Suspense fallback={fallback ? fallback : loading()}>
        <Component/>
    </Suspense>
);
